// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { KeycloakConfig } from 'keycloak-js';

const keycloakConf: KeycloakConfig = {
    url: 'https://sso.upra.gov.co/',
    realm: 'siriiagro',
    clientId: 'siriiagro-frontend',
};

export const environment = {
    production: true,
    base: 'siriiagro',
    apiRest: 'https://appprdvsiriiagrofrontendeastus0201.azurewebsites.net/',
    pruebas: true,
    fechaVersion: '05-10-2020',
    version: '1.0.0',
    keycloakConf: keycloakConf,
    apiSiriUrl: 'https://appprdsiriiagrobackendeastus0201.azurewebsites.net/',
    dominiosInstitucionales: ['@upra.gov.co', '@minagricultura.gov.co'],
};
